import { render } from "./quoteStoryCard.vue?vue&type=template&id=18c8c7a0"
import script from "./quoteStoryCard.vue?vue&type=script&lang=js"
export * from "./quoteStoryCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__